export const FILES_PREFIX = '@FILES';
